interface CountBadgeProps {
  /** Raw count. The badge renders nothing when this is 0 or less. */
  count: number;
  /** Counts above this show as `${max}+`. Defaults to 99. */
  max?: number;
  /**
   * Position (and any other) classes for the badge. The caller owns
   * placement since the corner offset depends on the host control; the
   * visual style (red circle, white bold text) is fixed here so every
   * badge looks the same.
   */
  className?: string;
}

/**
 * The small red count bubble that overlays a control's upper-right corner
 * (notification bell, connections button, …). Style is centralized here so
 * the look stays consistent everywhere; callers supply only the count and
 * the corner-offset classes via `className`.
 */
export const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  max = 99,
  className = '',
}) => {
  if (count <= 0) return null;

  return (
    <span
      className={`absolute flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-xs font-bold text-white ${className}`}
    >
      {count > max ? `${max}+` : count}
    </span>
  );
};
